export const HANDLE_HOVER_SCALE = 1.25;
export const RAIL_HOVERED_HANDLE_CLASS = 'rail-hovered';
export const RAIL_CLASS = 'rail-hover-target';
